import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ taskId = '', signal, ...params } = {}) => {
  return await dponetAPI.get(`/kanban_tasks/${taskId}`, { params, signal })
}

const create = async (data) => {
  return await dponetAPI.post('/kanban_tasks', { task: data })
}

const update = async ({ taskId, ...data }) => {
  return await dponetAPI.put(`/kanban_tasks/${taskId}`, { task: data })
}

const finalize = async ({ taskId }) => {
  return await dponetAPI.patch(`/kanban_tasks/${taskId}/finalize`)
}

const move = async ({ taskId, kanbanColumnId, position }) => {
  return await dponetAPI.patch(`/kanban_tasks/${taskId}/move`, {
    kanbanColumnId,
    position,
  })
}

const destroy = async ({ taskId }) => {
  return await dponetAPI.delete(`/kanban_tasks/${taskId}`)
}

const uploadAttachments = async ({ taskId, attachments }) => {
  const data = {}
  Array.from(attachments).forEach((file, index) => {
    data[`attachment-${index}`] = file
  })
  return await dponetAPI.postForm(
    `/kanban_tasks/${taskId}/add_attachment`,
    data,
  )
}

const destroyAttachment = async ({ taskId, attachmentId }) => {
  return await dponetAPI.delete(
    `/kanban_tasks/${taskId}/attachment/${attachmentId}`,
  )
}

const getLogs = async ({ taskId }) => {
  return await dponetAPI.get(`/kanban_tasks/${taskId}/logs`)
}

const batch = async ({ columnIds, signal, ...params } = {}) => {
  return await dponetAPI.get('/kanban_tasks/batch', {
    params: { columnIds, ...params },
    signal,
  })
}

const stats = async () => {
  return await dponetAPI.get('/kanban_tasks/stats')
}

const crossBoardStats = async () => {
  return await dponetAPI.get('/kanban_tasks/cross_board_stats')
}

const automaticStats = async () => {
  return await dponetAPI.get('/kanban_tasks/automatic_stats')
}

const generateReport = async (params) => {
  return await dponetAPI.post('/kanban_tasks/export_report', params)
}

const kanbanTasks = {
  automaticStats,
  batch,
  create,
  crossBoardStats,
  destroy,
  destroyAttachment,
  finalize,
  generateReport,
  get,
  getLogs,
  move,
  stats,
  update,
  uploadAttachments,
}

export default kanbanTasks
